import StandardGateway from 'scripts/adapters/gateways/lib/standard_gateway';

/**
 * Thin read-only gateway for the configured-external-apps UI forms metadata endpoint
 * (`GET /api/v1/orgs/:orgId/configured-external-apps/ui-forms-meta`). Configured as
 * `fetchUrl` only, so `fetch()` issues a plain GET with no MQTT subscription.
 *
 * NOT called at runtime by the main SPA. It exists solely to pin the
 * agent-desktop → configured-external-apps consumer pact contract
 * (see `__specs__/external_app_forms_meta_gateway_pact_spec.js`) on behalf of the admin
 * Customer Profile page, which consumes this endpoint through its own resource
 * (`admin/src/actions/externalApps/uiFormsMetaResource.ts`) and cannot run pact tests.
 */
export default class ExternalAppFormsMetaGateway extends StandardGateway {
  constructor(backend) {
    super(backend, {
      fetchUrl: '/api/v1/orgs/:orgId/configured-external-apps/ui-forms-meta',
    });
  }
}
